import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title } from '../../components/Shared/TitleSuccess';

const TitleComponent = () => <Title>Thanks! You’re not quite done yet.</Title>;

TitleComponent.propTypes = {};

const VoteRegistrationSuccessFinal = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            titleComponent={<TitleComponent />}
            hideSubtitle={true}
            {...props}
        />
    </TransitionContainerNoExit>
);

VoteRegistrationSuccessFinal.propTypes = {
    thankYouText: PropTypes.string.isRequired
};

export default connect(
    state => ({
        thankYouText: `Your voter <a target="_blank" href="${
            state.voteRegistration.completeVoteRegistration.pdfUrl
        }">registration forms are complete</a>, but you still need to sign and mail them to the address located on the form. We've also emailed the form to the address you gave us so you have access to it later.`
    }),
    {}
)(VoteRegistrationSuccessFinal);



// WEBPACK FOOTER //
// ./src/containers/VoteRegistration/VoteRegistrationSuccessFinal.jsx